module.exports = __webpack_public_path__ + "img/涂建國.11f29b96.jpg";